var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3,
    width: 7,
    height: 18,
    rx: 2,
    fill: "#87DDB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14V14C4.89543 14 4 13.1046 4 12V8C4 6.89543 4.89543 6 6 6H18C19.1046 6 20 6.89543 20 8V12C20 13.1046 19.1046 14 18 14H15",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91051 18.9091H10.8139L10.8182 17.9332C12.6463 17.8011 13.6946 16.7955 13.6989 15.3679C13.6946 13.8551 12.446 13.1648 11.1335 12.8537L10.8523 12.7813L10.8693 10.348C11.5511 10.4673 11.9901 10.8764 12.0582 11.4901H13.5795C13.554 10.1349 12.4886 9.14631 10.8778 8.9929L10.8821 8H9.97869L9.97443 8.9929C8.37642 9.15483 7.22585 10.1349 7.23011 11.5455C7.23011 12.7983 8.12074 13.5185 9.55682 13.8892L9.94034 13.9872L9.9233 16.5653C9.16051 16.446 8.6108 16.0114 8.5554 15.2401H7C7.05966 16.8381 8.15909 17.7884 9.91477 17.9332L9.91051 18.9091ZM10.8267 16.5653L10.8438 14.2259C11.6193 14.4517 12.1136 14.75 12.1179 15.3551C12.1136 15.9858 11.6065 16.4375 10.8267 16.5653ZM9.94886 12.5511C9.3608 12.3636 8.82386 12.0526 8.83239 11.4474C8.83665 10.8977 9.25 10.4716 9.96591 10.348L9.94886 12.5511Z",
    fill: "#272932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyField);
export default __webpack_public_path__ + "static/media/Currency Field.62dad46185c45db6b6ff61f9de3f5e95.svg";
export { ForwardRef as ReactComponent };